import { User as IUser } from "@/websocket/model/user";
import { UserType } from "@/websocket/model/enums/user-type";
import { normalizeLength } from "@/websocket/utils/messages";

export class User implements IUser {
    constructor(
        public type: UserType,
        public id?: string,
    ) {}
    toString(): string {
        return this.type + normalizeLength(this.id, 10);
    }
    public static fromString(string: string) {
        const type = string.slice(0, 1) as unknown as UserType;
        const id = type === UserType.User ? string.slice(1) : undefined;
        return new User(type, id);
    }
}
